import React from "react";

const ServicesSection = () => {
  const data = [
    { n: 1, name: "Html 5" },
    { n: 2, name: "Css 3" },
    { n: 3, name: "Sass" },
    { n: 4, name: "TailwindCSS" },
    { n: 5, name: "JavaScript" },
    { n: 6, name: "TypeScript" },
    { n: 7, name: "React" },
    { n: 8, name: "Redux" },
    { n: 9, name: "NextJS" },
    { n: 11, name: "RNative" },
    { n: 12, name: "JestJS" },
    { n: 20, name: "Playwright" },
    { n: 13, name: "NodeJS" },
    { n: 24, name: "Docker" },
    { n: 14, name: "CI / CD" },
    { n: 17, name: "Git" },
  ];

  return (
    <section
      id="ServicesSection"
      className="flex flex-col items-center justify-between space-y-20 pt-24 pb-32"
    >
      <div className="space-y-8">
        <h1 className="text-5xl text-center leading-tight">
          Skills <span>💡</span>
        </h1>
        <p className="text-center text-sm font-normal leading-loose opacity-60">
          Those are all the technologies that I know & love to use.
        </p>
      </div>
      <ul className="mx-auto grid grid-cols-2 items-center justify-between gap-14 md:gap-24 p-4 text-sm font-normal leading-loose opacity-80 md:order-1 lg:max-w-[11946px] md:grid-cols-3 lg:grid-cols-4">
        {data.map((icon, i) => {
          return (
            <li
              key={i}
              className="cursor-pointer flex flex-col items-center justify-center space-y-2 p-6 shadow-2xl rounded-full"
            >
              <img
                alt="skills-icon"
                src={`/images/Skills/${icon.n}.png`}
                className="w-16 h-16"
              ></img>
              <p className="text-base font-normal leading-loose opacity-90">
                {icon.name}
              </p>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default ServicesSection;
